import React from 'react'

const Deliveryservice = () => {
  return (
    <div className='container'>
        <div className='text-xl'><strong>Delivery Services</strong></div>
        <div className='mt-4'>
      At the moment, Campusify does not offer any delivery services. However, we partner with logistics companies to provide delivery services to our customers.In doing so, we offer third party delivery service.<strong> Please contact any of the following hotlines to request for delivery: 08164910957, 09068412463</strong>
        </div>
    </div>
  )
}

export default Deliveryservice